import { useState, useEffect } from 'react';
import { X } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

export function ExitIntentPopup() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('nexa_exit_popup');
    if (hasSeenPopup) return;

    const handleMouseLeave = (e) => {
      if (e.clientY <= 0) {
        setIsOpen(true);
        localStorage.setItem('nexa_exit_popup', 'true');
        document.removeEventListener('mouseout', handleMouseLeave);
      }
    };

    // Delay adding the listener
    const timer = setTimeout(() => {
      document.addEventListener('mouseout', handleMouseLeave);
    }, 15000);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('mouseout', handleMouseLeave);
    };
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 popup-overlay"
          onClick={handleClose}
          data-testid="exit-intent-popup"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white rounded-lg shadow-2xl max-w-lg w-full overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative bg-nexa-stone p-8 text-center">
              <button
                onClick={handleClose}
                className="absolute top-3 right-3 text-nexa-charcoal/60 hover:text-nexa-charcoal transition-colors"
                data-testid="close-exit-popup"
              >
                <X size={24} />
              </button>
              
              <p className="text-nexa-gold text-sm uppercase tracking-widest font-semibold mb-2">
                Wait! Before you go...
              </p>
              <h3 className="font-serif text-4xl font-semibold text-nexa-charcoal mb-4">
                15% Off Your Order
              </h3>
              <p className="text-muted-foreground mb-6">
                Use code <span className="font-semibold text-nexa-charcoal">STAY15</span> at checkout
              </p>
              
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Link to="/shop" onClick={handleClose}>
                  <Button className="btn-gold w-full sm:w-auto" data-testid="exit-shop-btn">
                    Shop Now
                  </Button>
                </Link>
                <Button 
                  variant="outline" 
                  className="border-nexa-charcoal text-nexa-charcoal hover:bg-nexa-charcoal hover:text-white"
                  onClick={handleClose}
                  data-testid="exit-close-btn"
                >
                  No Thanks
                </Button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
